import { z } from "zod";

export type EditCatalogViewSchema = z.infer<ReturnType<typeof getEditCatalogViewSchema>>;

export const getEditCatalogViewSchema = () => {
	const propertyObjectSchema = z.object({
		id: z.string(),
		value: z.array(z.string()).optional(),
	});

	return z.object({
		// Trim first: a name of spaces is an empty name, and the form must say so instead of
		// leaving the user with a button that never lights up.
		name: z.string().trim().min(1),
		filters: z.array(propertyObjectSchema),
		properties: z.array(propertyObjectSchema),
		groupBy: z.array(z.string()).optional(),
		options: z
			.object({
				docportalVisible: z.boolean().optional(),
			})
			.optional(),
	});
};
